import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { AppointmentResponse, Customers, CustomersResponse, Event } from '../types';
import { showNotification } from '@/utils/notificationUtils';
type UseBusinessOptions = {
  businessId?: number;
  businessLocationId?: number | string;
  page: number;
  perPage: number;
  search?: string;
  petTypes?: string[];
};
export const getCustomerList = (
  { businessId, page, perPage, businessLocationId, petTypes, search }: UseBusinessOptions = {
    page: 1,
    perPage: 10,
  }
): Promise<CustomersResponse> => {
  return axios.get(`/business/customers/list`, {
    params: {
      businessId,
      businessLocationId,
      page,
      perPage,
      search,
      petType: petTypes && petTypes.length > 0 ? petTypes.toString() : undefined,
    },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getCustomerList>;
};

export const useGetCustomers = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCustomerList,
  });
};

type UseCustomerOptions = {
  id?: number;
  phone?: string;
};
export const getCustomersDetails = ({ id, phone }: UseCustomerOptions = {}): Promise<Customers> => {
  return axios.get(phone ? `/business/customerbyphone/${phone}` : `/business/customers/${id}`, {});
};

type UseUpdateCustomerOptions = {
  config?: MutationConfig<typeof getCustomersDetails>;
};

export const useGetCustomersDetails = ({ config }: UseUpdateCustomerOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCustomersDetails,
  });
};

type UseCustomerOptionss = {
  id?: number;
};
export const deleteCustomer = ({ id }: UseCustomerOptionss = {}): Promise<Customers> => {
  return axios.delete(`/business/delete-customer/${id}`);
};

type UseUpdateCustomerOptionss = {
  config?: MutationConfig<typeof deleteCustomer>;
};

export const useDeleteCustomer = ({ config }: UseUpdateCustomerOptionss = {}) => {
  return useMutation({
    ...config,
    mutationFn: deleteCustomer,
  });
};
